import {
  Button,
  ButtonVariant,
  Layout,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  withTheme,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import React from 'react';
import { TranslationsContext } from '../../common/contexts';
import { IPageName } from '../../common/types/apiSchema';
import { getPaths } from '../../constants/paths/paths';
import { ICancellationCompleteProps } from './CancellationPage.interfaces';
import { DisclaimerText } from './CancellationPage.styles';

const CancellationComplete: React.FunctionComponent<ICancellationCompleteProps> = ({
  summaryProps,
}) => {
  const { translations } = React.useContext(TranslationsContext);

  const navigateToBookingPage: () => void = () => {
    window.location.assign(getPaths(IPageName.bookingsPage)[0]);
  };

  const navigateToCurrentSalesPage: () => void = () => {
    window.location.assign(getPaths(IPageName.currentSales)[0]);
  };

  return (
    <React.Fragment>
      <ResponsiveTypography variant={ResponsiveTypographyVariant.t5SansBold}>
        {i18n('cancellation.cancelled', [], translations)}
      </ResponsiveTypography>
      <DisclaimerText variant={ResponsiveTypographyVariant.body} allowDangerousRender={true}>
        {i18n(
          summaryProps.creditRefund ? 'cancellation.credit.processing' : 'cancellation.processing',
          [
            summaryProps.cancellationSummary.toBeRefundedBreakdown.total.forDisplay,
            summaryProps.refundDuration,
          ],
          translations
        )}
      </DisclaimerText>
      <Layout.Container flexDirection={'column'} alignItems={'center'}>
        <Button variant={ButtonVariant.primary} onClick={navigateToCurrentSalesPage}>
          {i18n('cancellation.see.deals', [], translations)}
        </Button>
        <Button variant={ButtonVariant.text} onClick={navigateToBookingPage}>
          {i18n('cancellation.back.to.bookings', [], translations)}
        </Button>
      </Layout.Container>
    </React.Fragment>
  );
};

export default withTheme(CancellationComplete);
